import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b444851"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"padding":"15px"}
}
const _hoisted_2 = { class: "detail-container" }
const _hoisted_3 = { class: "collapse-title-wrapper" }
const _hoisted_4 = { class: "collapse-title-wrapper" }
const _hoisted_5 = {
  class: "item",
  style: {"padding-top":"0","max-height":"720px","height":"500px"},
  id: `section-1`,
  "data-section": "1"
}
const _hoisted_6 = { class: "collapse-title-wrapper" }
const _hoisted_7 = {
  class: "",
  id: `section-2`,
  "data-section": "2",
  style: {"padding-top":"0","max-height":"720px","height":"500px"}
}
const _hoisted_8 = { class: "collapse-title-wrapper" }
const _hoisted_9 = {
  class: "",
  style: {"padding-top":"5px","max-height":"740px","height":"500px"},
  id: `section-3`,
  "data-section": "3"
}
const _hoisted_10 = { class: "collapse-title-wrapper" }
const _hoisted_11 = {
  style: {"max-height":"740px","height":"500px"},
  id: `section-4`,
  "data-section": "4"
}
const _hoisted_12 = { class: "collapse-title-wrapper" }
const _hoisted_13 = {
  id: `section-5`,
  "data-section": "5"
}
const _hoisted_14 = {
  class: "gap-y-15",
  style: {"padding":"15px 20px","position":"relative"}
}
const _hoisted_15 = {
  style: {"position":"absolute","right":"15px","top":"10px","text-decoration":"none"},
  class: "cm-align-center",
  href: "/help/repair-help",
  target: "_blank"
}
const _hoisted_16 = { class: "cm-link-light cm-ui-ml5" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { style: {"color":"var(--cm-color-text-secondary)"} }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { style: {"color":"var(--cm-color-text-secondary)"} }
const _hoisted_21 = { class: "time-info" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "label cm-align-center" }
const _hoisted_25 = { style: {"color":"var(--cm-color-text-secondary)"} }
const _hoisted_26 = {
  class: "cm-align-center",
  style: {"flex":"0 1 auto"}
}
const _hoisted_27 = { class: "cm-ui-ml5 cm-ui-mr5" }
const _hoisted_28 = { class: "cm-ui-ml5 cm-ui-mr5" }
const _hoisted_29 = { class: "cm-align-center" }
const _hoisted_30 = {
  class: "cm-ui-ml30",
  style: {"display":"flex","align-items":"center","flex":"0 1 auto"}
}
const _hoisted_31 = { class: "select-txt-box" }
const _hoisted_32 = { class: "cm-ui-ml30 select-fix-box" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-item-icon" }, null, -1))
const _hoisted_34 = { class: "collapse-title-wrapper" }
const _hoisted_35 = {
  class: "",
  style: {"max-height":"740px","height":"500px","padding":"15px 0","box-sizing":"border-box"},
  id: `section-6`,
  "data-section": "6"
}
const _hoisted_36 = { class: "collapse-title-wrapper" }
const _hoisted_37 = {
  class: "",
  style: {},
  id: `section-7`,
  "data-section": "7"
}

import { computed, nextTick, onBeforeUnmount, PropType, reactive, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import LastRemoverTab from '@/views/dashboard/safe-status/loaris-trojan-remover/_components/remover-details/last-remover-tab.vue';
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue';
import TerminalHeadRemoteActions from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head-remote-actions.vue';
import Anchor from '@/components/anchor/anchor.vue';
import BaseInfo from './BaseInfo.vue';
import PortListDrawer from '@/views/dashboard/manage/port-manage/_components/terminal-view/_components/port-list-drawer/port-list-drawer.vue';
import BaseLineDetail from '@/views/dashboard/safe-status/base-line/_components/base-line-detail/base-line-detail.vue';
import RepairDrawer from '@/views/dashboard/safe-status/vulnerability-fix/_components/terminal-view-table/_components/repair-drawer.vue';
import AccountInfo from './AccountInfo.vue';
import ProcessInfo from './ProcessInfo.vue';
import { useReflectiveInjector } from '@tanbo/vue-di-plugin';
import { TerminalType } from '@/views/dashboard/_enum/terminal-type';
import { ElMessage } from 'element-plus';
import { RiskTerminalList } from '../service';
import { BaseLineService, ScanParams } from '@/views/dashboard/safe-status/base-line/base-line.service';
import { BaseLineScanTerminalDrawerService } from '@/views/dashboard/safe-status/base-line/_components/baseLine-scan-terminal-drawer/baseLine-scan-terminal-drawer.service';
import { TerminalAuthStatus } from '@/views/dashboard/_enum/terminal-auth-status';
import { AreaType } from '@/views/dashboard/service/_enum/area-type';
import { getAuthByList, PermissionFe, ServicePermissionService } from '@/services/service-permission.service';
import { BaseLineRepairDrawerService, IdsCount, RepairParams, RepairTerminalItem } from '@/views/dashboard/safe-status/base-line/_components/baseLine-repair-drawer/baseLine-repair-drawer.service';
import { SystemType } from '@/views/dashboard/safe-status/base-line/repair-item-tree-type';
import { RiskDetail } from '../service';
import WindowsRepairWrapper from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/repair-system-wrapper/windows-repair-wrapper.vue'
import LinuxRepairWrapper
  from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/repair-system-wrapper/linux-repair-wrapper.vue'
import { formLabelStyle } from '@/components/cmForm/globalOpt';
import RansomwareIncidentDetail from '@/views/dashboard/data-safe/ransomware-protection/ransomware-incident-detail.vue';
import { EventListItem } from '@/views/dashboard/data-safe/ransomware-protection/service';
import RansomwareIncidentList from '@/views/dashboard/data-safe/ransomware-protection/_components/ransomware-incident-list/ransomware-incident-list.vue';
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'

const SECTION_TAB_COUNT = 8

export default /*#__PURE__*/_defineComponent({
  __name: 'DataDetail',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  activeHref: {
    type: [String, Number],
    default: 1
  },
  api: {
    type: Object,
    default: () => ({
      getTerminalRiskDetailApi: () => { },
      getTerminalOrderGetWeakPasswordInfoApi: () => { },
      getTerminalOrderGetProcessInfoApi: () => { },
      getTerminalAccountLoginSessionHistory: () => { },
    })
  },
  detailInfo: {
    type: Object as PropType<RiskTerminalList | any>,
    default: () => ({})
  }
},
  emits: ['update:modelValue', 'handleNet', 'refresh'],
  setup(__props, { emit: __emit }) {


const { t, locale } = useI18n()

const props = __props
const injector = useReflectiveInjector([BaseLineService, BaseLineScanTerminalDrawerService, BaseLineRepairDrawerService])
const servicePermissionService = injector.get(ServicePermissionService)
const hasPortPermission = servicePermissionService.getHasPermission(PermissionFe.port_control)
const visibleDetail = ref(false)
const ransomDetailInfo = ref<EventListItem>({} as EventListItem)
const baseLineService = injector.get(BaseLineService)
const terminalService = injector.get(BaseLineScanTerminalDrawerService)
const emits = __emit
const incidentDrawerVisible = ref(false)
const visible = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value)
  },
})

function handleDetail(item: EventListItem) {
  ransomDetailInfo.value = item
  visibleDetail.value = true
}
const refresh = () => {
  getRiskDetail()
}
const repairItemDrawer = ref(false)
const activeName = ref('baseline-win-terminals')

const openRepairItemDrawer = () => {
  repairItemDrawer.value = true
}
// 修复/扫描
const cmpAuth_status = computed(() => props.detailInfo.auth_status.reduce((p, c) => (p[c.permission_name] = c.auth_status, p), {}))
const ModulePermissionKey = {
  [AreaType.linux]: PermissionFe.linux_base_auth,
}
const isDisabled = () => {
  return getAuthByList(cmpAuth_status.value[PermissionFe.linux_base_auth].auth_status, ModulePermissionKey[props.detailInfo.area_type]) !== TerminalAuthStatus.normal
}
// 检查基线修复权限
const isRepairDisabled = () => {
  if (!props.detailInfo?.device_id) return true
  // 检查是否有修复项
  if (!repairData.alen && !repairData.nlen) return true
  // 检查权限
  const permissionKey = ModulePermissionKey[props.detailInfo.area_type]
  if (permissionKey && props.detailInfo.auth_status) {
    const authStatus = getAuthByList(props.detailInfo.auth_status, permissionKey)
    return authStatus !== TerminalAuthStatus.normal
  }
  return false
}
const handleNet = () => {
  emits('handleNet', props.detailInfo)
}
const activeNames = ref(Array.from({ length: SECTION_TAB_COUNT }, (_, index) => String(index)))

const detailTabLabels = computed<Record<number, string>>(() => {
  void locale.value
  return {
    0: t('responseHandle.detailTabRiskOverview'),
    1: t('responseHandle.detailTabVirusRisk'),
    2: t('responseHandle.detailTabRansomwareRisk'),
    3: t('responseHandle.detailTabPortInfo'),
    4: t('responseHandle.detailTabLeakInfo'),
    5: t('responseHandle.detailTabBaselineInfo'),
    6: t('responseHandle.detailTabAccountInfo'),
    7: t('responseHandle.detailTabProcessInfo'),
  }
})
const contentRef = ref<HTMLElement | null>(null)
const formatSectionHref = (value: string | number) => {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') {
    return value.startsWith('#') ? value : `#section-${value}`
  }
  return `#section-${value}`
}
const activeHref = ref(formatSectionHref(props.activeHref as string | number))
const anchorRef = ref<InstanceType<typeof Anchor> | null>(null)
const accountRef = ref(null)
const baseLineDetailRef = ref<InstanceType<typeof BaseLineDetail> | null>(null)

// 使用 Anchor 组件的 scrollTo 方法进行定位
const scrollToActiveSection = () => {
  const href = activeHref.value
  if (!href || !anchorRef.value) return
  // 使用 Anchor 组件的 scrollTo 方法
  anchorRef.value.scrollTo(href)
}

const syncActiveSection = (value: string | number) => {
  const next = formatSectionHref(value)
  if (!next) return
  activeHref.value = next
}
// 扫描
const handleScan = () => {
  if (!props.detailInfo?.device_id) return
  const params: ScanParams = {
    select_type: 1,
    device_list: [props.detailInfo.device_id],
    group_id: props.detailInfo.group_id || -1
  }
  isScan.value = true
  baseLineService.getBaseLineCheckCheck(params).then(response => {
    // 保存 task_id 到 localStorage（参考 baseLine-scan-terminal-drawer）
    if (response.task_id) {
      localStorage.setItem('BASELINE_SCAN_TASK_ID', response.task_id)
      // 只要有 task_id 就开始轮询扫描结果
      if (props.detailInfo.login_status === 1) {
        handleDoneScan(response.task_id)
        ElMessage.success({ message: t('responseHandle.scanCmdSent'), center: true })
      } else {
        ElMessage.warning({ message: t('safeProtectionModule.rescanPendingReboot'), center: true })
      }
    } else {
      // 没有 task_id，停止扫描状态
      isScan.value = false
      ElMessage.error(t('responseHandle.scanFailNoTaskId'))
    }
  }).catch((error) => {
    isScan.value = false
    console.error('扫描失败:', error)
    ElMessage.error(t('responseHandle.scanFailedGeneric'))
  })
}
// 扫描结果
const isScan = ref(false)
const scanResult = ref({})
let scanInterval: number | null = null
// 扫描按钮文字
const scanButtonText = computed(() => {
  void locale.value
  return isScan.value ? t('responseHandle.dataDetailBaselineScanning') : t('safeProtectionModule.baselineStartScan')
})
const handleDoneScan = (scanTaskId: string) => {
  // 清除之前的轮询
  if (scanInterval) {
    clearInterval(scanInterval)
  }
  scanInterval = setInterval(() => {
    terminalService.getScanResult({ task_id: scanTaskId }).then(res => {
      scanResult.value = res
      if (res.is_finish) {
        isScan.value = false
        ElMessage.success(t('safeProtectionModule.scanComplete'))
        if (scanInterval) {
          clearInterval(scanInterval)
          scanInterval = null
        }
        // 扫描完成后刷新数据
        refresh()
        // 重新获取修复数据
        getRepairDataCount()
        // 更新基线详情数据
        baseLineDetailRef.value?.getData?.()
      }
    }).catch((error) => {
      console.error('获取扫描结果失败:', error)
      // 网络错误时不停止轮询，继续尝试获取结果
      // 只有在明确失败时才停止（这里可以根据实际需求调整）
    })
    // eslint-disable-next-line no-magic-numbers
  }, 3000)
}
// 立即修复
const repairData = reactive({
  total: 0,
  alen: 0,
  nlen: 0,
  ilen: 0,
  autoIDs: [] as string[],
  notifyIDs: [] as string[],
  hasWindows: true,
  hasLinux: true,
  subIds: [] as string[]
})
const service = injector.get(BaseLineRepairDrawerService)

const handleReFix = () => {
  if (!props.detailInfo?.device_id) return
  // 检查是否有修复项
  if (!repairData.alen && !repairData.nlen) {
    ElMessage.warning(t('safeProtectionModule.noRepairSelected'))
    return
  }
  const params: RepairParams = {
    select_type: 1,
    group_id: props.detailInfo.group_id,
    device_list: [props.detailInfo.device_id],
    repair_item_ids: repairData.autoIDs,
    notice_item_ids: repairData.notifyIDs
  }
  service.getRepairNotification(params).then((res) => {
    if (repairData.alen) {
      // 如果有自动修复项，可以在这里处理任务ID（如果需要轮询修复结果）
      ElMessage.success(t('responseHandle.repairNotifySentWithAutoFix'))
      // 触发刷新，更新数据
      refresh()
    } else {
      ElMessage.success(t('safeProtectionModule.repairNotifySent'))
      // 触发刷新，更新数据
      refresh()
    }
  }).catch((error) => {
    console.error('修复通知下发失败:', error)
    ElMessage.error(t('responseHandle.repairNotifyFailed'))
  })
}
const setCountData = (sids: string[]) => {
  const lens: IdsCount = service.generateIDs(sids)
  repairData.alen = lens.alen
  repairData.nlen = lens.nlen
  repairData.ilen = lens.ilen
  repairData.total = lens.total
  repairData.autoIDs = lens.autoIDs
  repairData.notifyIDs = lens.notifyIDs
}
const getRepairDataCount = () => {
  if (!props.detailInfo?.device_id) return
  repairData.total = 0
  repairData.alen = 0
  repairData.nlen = 0
  repairData.ilen = 0
  service.getSubStandardIds({
    select_type: 1,
    group_id: props.detailInfo.group_id,
    device_list: [props.detailInfo.device_id]
  }).then(res => {
    repairData.subIds = res.substandard_ids
    setCountData(res.substandard_ids)
    repairData.hasWindows = [SystemType.Windows, SystemType.WinServer].includes(props.detailInfo.system_type)
    repairData.hasLinux = props.detailInfo.system_type === SystemType.Linux
  }).catch(err => {
    console.error('获取基线不合规数据失败:', err)
    repairData.subIds = []
    setCountData([])
  })
}
// 当 activeHref prop 变化时，同步并滚动
watch(
  () => props.activeHref,
  (val) => {
    if (val === undefined || val === null) return
    syncActiveSection(val as string | number)
    // 如果 drawer 已经打开，立即滚动
    if (visible.value) {
      nextTick(() => {
        scrollToActiveSection()
      })
    }
  },
  { immediate: true }
)

// 当 drawer 打开时，滚动到对应的位置
watch(
  () => visible.value,
  async (drawerVisible) => {
    if (drawerVisible && props.detailInfo?.device_id) {
      await nextTick()
      getRepairDataCount()
      accountRef.value?.updateData?.()
      // 等待 drawer 动画完成和 DOM 渲染后再滚动
      // 使用 requestAnimationFrame 确保 DOM 已完全渲染
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (activeHref.value) {
            scrollToActiveSection()
          }
        }, 200)
      })
    }
  }
)
// 获取风险数据
const riskData = ref<Partial<RiskDetail>>({
  virus_risk: { untreated_virus_count: 0, virus_types: [] },
  ransomware_risk: [],
  leak_risk: [],
  baseline_risk: { scan_item_count: 0, violation_item_count: 0 },
  port_risk: { open_port_count: 0, risk_port_count: 0, unknown_port_count: 0 },
  weak_password_risk: { account_count: 0, weak_password_account_count: 0 }
})

// 计算风险数量
const ransomwareCmp = computed(() => riskData.value.ransomware_risk?.reduce((p, c) => (p[c.level] = (c.ransomware_count || 0), p), {} as Record<number, number>) || {})
const leakCmp = computed(() => {
  return (riskData.value.leak_risk || []).reduce((p, c) => {
    if (c.warn_level === 0) {
      // 可选
      p[0] = (p[0] || 0) + (c.leak_count || 0)
    } else {
      // 高危（所有非0的都算高危）
      p[1] = (p[1] || 0) + (c.leak_count || 0)
    }
    return p
  }, {} as Record<number, number>)
})
const totalRansomwareCount = computed(() => Object.values(ransomwareCmp.value).reduce((p: number, c: number) => (p = p + c, p), 0))
const totalLeakCount = computed(() => Object.values(leakCmp.value).reduce((p: number, c: number) => (p = p + c, p), 0))

// 获取风险详情
const getRiskDetail = async () => {
  if (!props.detailInfo?.device_id || !props.api.getTerminalRiskDetailApi) return
  try {
    const result = await props.api.getTerminalRiskDetailApi({ device_id: props.detailInfo.device_id })
    riskData.value = result?.risk_detail || riskData.value
    console.log(riskData.value)
  } catch (error) {
    console.error('获取风险详情失败:', error)
  }
}

// 监听 detailInfo 变化，获取风险数据
watch(
  () => props.detailInfo?.device_id,
  (nv, lv) => {
    if (nv && nv !== lv) {
      getRiskDetail()
      getRepairDataCount()
    }
  },
  { immediate: true }
)

// 计算每个导航项的风险数量（根据BaseInfo.vue中的实际使用）
const riskCountMap: Record<number, () => number> = {
  0: () => getRiskCount(1) + getRiskCount(3) + getRiskCount(4) + getRiskCount(5) + getRiskCount(5) + getRiskCount(6), // 风险概况
  1: () => riskData.value.virus_risk?.untreated_virus_count || 0, // 病毒风险
  2: () => totalRansomwareCount.value, // 勒索风险
  3: () => (riskData.value.port_risk?.risk_port_count || 0), // 端口信息
  4: () => totalLeakCount.value, // 漏洞信息
  5: () => riskData.value.baseline_risk?.violation_item_count || 0, // 基线信息
  6: () => riskData.value.weak_password_risk?.weak_password_account_count || 0, // 账户信息
  7: () => 0, // 进程信息
}

const getRiskCount = (index: number): number => {
  return riskCountMap[index]?.() ?? 0
}

function getRiskStatusText(index: number, count: number, hasRisk: boolean): string {
  if (!hasRisk) {
    const safeByIndex: Record<number, string> = {
      0: t('responseHandle.collapseRiskNone'),
      1: t('responseHandle.collapseNoUntreatedRisks'),
      2: t('responseHandle.collapseNoRansomware'),
      3: t('responseHandle.collapseNoRiskPorts'),
      4: t('responseHandle.collapseNoRiskLeaks'),
      5: t('responseHandle.collapseNoBaselineItems'),
      6: t('responseHandle.collapseNoWeakPassword'),
      7: t('responseHandle.collapseNoRiskProcess'),
    }
    return safeByIndex[index] ?? ''
  }
  switch (index) {
    case 0:
      return t('responseHandle.collapseRiskExists')
    case 1:
      return t('responseHandle.collapseUntreatedRisks', { count })
    case 2:
      return t('responseHandle.collapseRansomwareRisks', { count })
    case 3:
      return t('responseHandle.collapseRiskPorts', { count })
    case 4:
      return t('responseHandle.collapseRiskLeaks', { count })
    case 5:
      return t('responseHandle.collapseBaselineItems', { count })
    case 6:
      return t('responseHandle.collapseWeakPasswordAccounts', { count })
    case 7:
      return t('responseHandle.collapseProcessRiskCount', { count })
    default:
      return ''
  }
}

// 获取风险状态信息（用于计算属性）
const getRiskStatus = (index: number) => {
  const count = getRiskCount(index)
  const hasRisk = count > 0
  return {
    count,
    hasRisk,
    dotClass: hasRisk ? 'collapse-risk-dot' : 'collapse-safe-dot',
    textClass: hasRisk ? 'collapse-risk-text' : 'collapse-safe-text',
    text: getRiskStatusText(index, count, hasRisk),
  }
}

// 为每个索引创建计算属性，优化性能（避免在模板中多次调用函数）
const riskStatusMap = computed(() => {
  void locale.value
  const map: Record<number, ReturnType<typeof getRiskStatus>> = {}
  for (let i = 0; i <= 7; i++) {
    map[i] = getRiskStatus(i)
  }
  return map
})

const anchorItems = computed(() => {
  void locale.value
  const labels = detailTabLabels.value
  return Array.from({ length: 8 }, (_, index) => index)
    .map((index) => ({
      title: labels[index],
      href: `#section-${index}`,
      riskCount: index !== 0 ? getRiskCount(index) : undefined,
    }))
    .filter((_item, index) => {
      if ([7, 6].includes(index) && props.detailInfo?.system_type === TerminalType.linux) {
        return false
      }
      return true
    })
})

// 组件卸载时清理定时器
onBeforeUnmount(() => {
  if (scanInterval) {
    clearInterval(scanInterval)
    scanInterval = null
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_date_format = _resolveDirective("date-format")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      size: "70%",
      title: _ctx.$t('responseHandle.detailTitle', { name: __props.detailInfo?.computer_name || __props.detailInfo?.device_id || '' })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (__props.detailInfo?.device_id)
            ? (_openBlock(), _createBlock(TerminalHead, {
                key: 0,
                "system-type": __props.detailInfo.system_type,
                detailInfo: __props.detailInfo,
                "login-status": __props.detailInfo.login_status
              }, {
                "right-action": _withCtx(() => [
                  _createVNode(TerminalHeadRemoteActions, {
                    "detail-info": __props.detailInfo,
                    onHandleNet: handleNet
                  }, null, 8, ["detail-info"])
                ]),
                _: 1
              }, 8, ["system-type", "detailInfo", "login-status"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Anchor, {
            ref_key: "anchorRef",
            ref: anchorRef,
            modelValue: activeHref.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeHref).value = $event)),
            items: anchorItems.value,
            offset: 50,
            container: contentRef.value,
            class: "detail-anchor"
          }, null, 8, ["modelValue", "items", "container"]),
          _createElementVNode("main", {
            ref_key: "contentRef",
            ref: contentRef,
            class: "content cm-ui-pl15"
          }, [
            _createVNode(_component_el_collapse, {
              modelValue: activeNames.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeNames).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, {
                  name: "0",
                  class: "el-card"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(_unref(formLabelStyle))
                      }, _toDisplayString(detailTabLabels.value[0]), 5),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[0].dotClass)
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[0].textClass)
                      }, _toDisplayString(riskStatusMap.value[0].text), 3)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(BaseInfo, {
                      data: { ...riskData.value, leakCmp: leakCmp.value, ransomwareCmp: ransomwareCmp.value, totalRansomwareCount: totalRansomwareCount.value, totalLeakCount: totalLeakCount.value }
                    }, null, 8, ["data"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_collapse_item, {
                  name: "1",
                  class: "el-card"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(_unref(formLabelStyle))
                      }, _toDisplayString(detailTabLabels.value[1]), 5),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[1].dotClass)
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[1].textClass)
                      }, _toDisplayString(riskStatusMap.value[1].text), 3)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      (__props.detailInfo?.device_id)
                        ? (_openBlock(), _createBlock(LastRemoverTab, {
                            key: 0,
                            class: "cm-ui-mt16",
                            ref: "lastRemoverTabRef",
                            lastSeven: true,
                            onRefresh: refresh,
                            "trojan-info": __props.detailInfo
                          }, null, 8, ["trojan-info"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_collapse_item, {
                  name: "2",
                  class: "el-card"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(_unref(formLabelStyle))
                      }, _toDisplayString(detailTabLabels.value[2]), 5),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[2].dotClass)
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[2].textClass)
                      }, _toDisplayString(riskStatusMap.value[2].text), 3)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(RansomwareIncidentList, {
                        device_id: __props.detailInfo.device_id,
                        lastSeven: true,
                        flag: false,
                        "has-permission": true,
                        viewMode: _unref(TableViewMode).full,
                        onDetail: handleDetail
                      }, null, 8, ["device_id", "viewMode"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_collapse_item, {
                  name: "3",
                  class: "el-card"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(_unref(formLabelStyle))
                      }, _toDisplayString(detailTabLabels.value[3]), 5),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[3].dotClass)
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[3].textClass)
                      }, _toDisplayString(riskStatusMap.value[3].text), 3)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      (__props.detailInfo?.device_id)
                        ? (_openBlock(), _createBlock(PortListDrawer, {
                            key: 0,
                            refreshApi: __props.api.getTerminalOrderGetWeakPasswordInfoApi,
                            onRefresh: refresh,
                            showDeviceInfo: false,
                            hasPermission: _unref(hasPortPermission),
                            device: { ...__props.detailInfo, auth_status: cmpAuth_status.value[_unref(PermissionFe).port_control] }
                          }, null, 8, ["refreshApi", "hasPermission", "device"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_collapse_item, {
                  name: "4",
                  class: "el-card"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(_unref(formLabelStyle))
                      }, _toDisplayString(detailTabLabels.value[4]), 5),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[4].dotClass)
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[4].textClass)
                      }, _toDisplayString(riskStatusMap.value[4].text), 3)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      (__props.detailInfo?.device_id)
                        ? (_openBlock(), _createBlock(RepairDrawer, {
                            key: 0,
                            style: {"padding":"10px 15px"},
                            "show-head-info": false,
                            "current-terminal": __props.detailInfo,
                            onRefresh: refresh
                          }, null, 8, ["current-terminal"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_collapse_item, {
                  name: "5",
                  class: "el-card"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(_unref(formLabelStyle))
                      }, _toDisplayString(detailTabLabels.value[5]), 5),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[5].dotClass)
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(riskStatusMap.value[5].textClass)
                      }, _toDisplayString(riskStatusMap.value[5].text), 3)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      (__props.detailInfo?.device_id)
                        ? (_openBlock(), _createBlock(BaseLineDetail, {
                            key: 0,
                            ref_key: "baseLineDetailRef",
                            ref: baseLineDetailRef,
                            "current-device": __props.detailInfo,
                            defaultExpand: false,
                            onRefresh: refresh
                          }, {
                            head: _withCtx(({ substandard_ids, check_item_ids, check_time, viewModel }) => [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("a", _hoisted_15, [
                                  _createVNode(_component_CmSvgIcon, {
                                    name: "assets/icons/question-solid-blue",
                                    monochrome: ""
                                  }),
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('responseHandle.dataDetailBaselineHelpLink')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('responseHandle.dataDetailBaselineResultLabel')), 1),
                                  _createElementVNode("div", {
                                    style: _normalizeStyle({ color: substandard_ids.length ? 'red' : 'green' })
                                  }, _toDisplayString(substandard_ids.length ? _ctx.$t('safeProtectionModule.nonCompliant') : _ctx.$t('safeProtectionModule.compliant')), 5)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('responseHandle.dataDetailScanTimeLabel')), 1),
                                  _createElementVNode("div", _hoisted_21, [
                                    check_time
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_22, null, 512)), [
                                          [_directive_date_format, check_time * 1000]
                                        ])
                                      : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('responseHandle.dataDetailNeverScanned')), 1))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('responseHandle.dataDetailCheckDetailLabel')), 1),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.dataDetailFoundPrefix')), 1),
                                    _createElementVNode("strong", _hoisted_27, _toDisplayString(substandard_ids.length), 1),
                                    _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.dataDetailFoundMid')), 1),
                                    _createElementVNode("strong", _hoisted_28, _toDisplayString(check_item_ids.length), 1),
                                    _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.dataDetailFoundSuffix')), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small",
                                    onClick: handleScan,
                                    disabled: isDisabled() || isScan.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scanButtonText.value), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]),
                                  _createVNode(_component_el_button, {
                                    plain: "",
                                    size: "small",
                                    disabled: isRepairDisabled(),
                                    onClick: handleReFix
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.repairNow')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.dataDetailRepairLine1')), 1),
                                      _createVNode(_component_el_button, {
                                        type: "text",
                                        onClick: openRepairItemDrawer,
                                        disabled: !repairData.total
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(repairData.total), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.dataDetailRepairLine2')), 1),
                                      _createVNode(_component_el_button, {
                                        style: {"margin-left":"0"},
                                        type: "text",
                                        onClick: openRepairItemDrawer,
                                        disabled: !repairData.alen
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(repairData.alen), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.dataDetailRepairLine3')), 1),
                                      _createVNode(_component_el_button, {
                                        type: "text",
                                        style: {"margin-left":"0"},
                                        onClick: openRepairItemDrawer,
                                        disabled: !repairData.nlen
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(repairData.nlen), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.dataDetailRepairLine4')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createVNode(_component_el_button, {
                                        type: "text",
                                        onClick: openRepairItemDrawer
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.selectRepairItems')), 1),
                                          _hoisted_33
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["current-device"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                (__props.detailInfo?.system_type !== _unref(TerminalType).linux)
                  ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                      key: 0,
                      name: "6",
                      class: "el-card"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("span", {
                            style: _normalizeStyle(_unref(formLabelStyle))
                          }, _toDisplayString(detailTabLabels.value[6]), 5),
                          _createElementVNode("span", {
                            class: _normalizeClass(riskStatusMap.value[6].dotClass)
                          }, null, 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(riskStatusMap.value[6].textClass)
                          }, _toDisplayString(riskStatusMap.value[6].text), 3)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_35, [
                          (__props.detailInfo?.device_id)
                            ? (_openBlock(), _createBlock(AccountInfo, {
                                key: 0,
                                refreshApi: __props.api.getTerminalOrderGetWeakPasswordInfoApi,
                                onRefresh: refresh,
                                ref_key: "accountRef",
                                ref: accountRef,
                                info: __props.detailInfo,
                                deviceId: __props.detailInfo.device_id,
                                api: __props.api.getTerminalAccountLoginSessionHistory
                              }, null, 8, ["refreshApi", "info", "deviceId", "api"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.detailInfo?.system_type !== _unref(TerminalType).linux)
                  ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                      key: 1,
                      name: "7",
                      class: "el-card"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("span", {
                            style: _normalizeStyle(_unref(formLabelStyle))
                          }, _toDisplayString(detailTabLabels.value[7]), 5),
                          _createElementVNode("span", {
                            class: _normalizeClass(riskStatusMap.value[7].dotClass)
                          }, null, 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(riskStatusMap.value[7].textClass)
                          }, _toDisplayString(riskStatusMap.value[7].text), 3)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, [
                          (__props.detailInfo?.device_id)
                            ? (_openBlock(), _createBlock(ProcessInfo, {
                                key: 0,
                                info: __props.detailInfo,
                                deviceId: __props.detailInfo.device_id
                              }, null, 8, ["info", "deviceId"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      size: "70%",
      modelValue: repairItemDrawer.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((repairItemDrawer).value = $event)),
      direction: "rtl",
      title: _ctx.$t('safeProtectionModule.selectRepairItems')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeName).value = $event)),
          style: {"padding":"0 0 0 15px"}
        }, {
          default: _withCtx(() => [
            (repairData.hasWindows)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 0,
                  label: _ctx.$t('safeProtectionModule.winTerminals'),
                  name: "baseline-win-terminals"
                }, {
                  default: _withCtx(() => [
                    _createVNode(WindowsRepairWrapper, {
                      "sub-ids": repairData.subIds
                    }, null, 8, ["sub-ids"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (repairData.hasLinux)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 1,
                  label: _ctx.$t('safeProtectionModule.linuxTerminals'),
                  name: "baseline-linux-terminals"
                }, {
                  default: _withCtx(() => [
                    _createVNode(LinuxRepairWrapper, {
                      "sub-ids": repairData.subIds
                    }, null, 8, ["sub-ids"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(RansomwareIncidentDetail, {
      modelValue: visibleDetail.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visibleDetail).value = $event)),
      detailInfo: ransomDetailInfo.value
    }, null, 8, ["modelValue", "detailInfo"])
  ], 64))
}
}

})